import { useNavigate } from "react-router-dom";

import PageContent from "components/partials/page-content/page-content";
import { CampaignForm } from "containers/admin/clients/campaign/components/campaign-form/campaign-form";
import toast from "components/partials/toast/toast";

import { useCurrentClient } from "hooks/api/use-clients";
import {
  CampaignAttributes,
  CampaignWriteBody,
  useCreateCampaign,
} from "hooks/api/use-campaigns";

import { getErrorMessage } from "utilities";
import { usePagePermission } from "hooks/use-page-permission";

import { Permission } from "types/auth";

const CampaignAddPage = () => {
  const navigate = useNavigate();
  const client = useCurrentClient();
  const createCampaignMutation = useCreateCampaign();

  usePagePermission(Permission.PERM_CAMPAIGN_WRITE);

  const createCampaign = async (attributes: CampaignWriteBody) => {
    try {
      return await createCampaignMutation.mutateAsync({
        clientId: client.id,
        data: attributes,
      });
    } catch (err) {
      toast.error({
        data: {
          title: "Failed to create campaign",
          message: getErrorMessage(err?.response?.data),
        },
      });
      throw err;
    }
  };

  const handleSuccess = (campaign: CampaignAttributes) => {
    toast.success({
      data: {
        title: "Created campaign",
      },
    });
    navigate(`/clients/${client.id}/campaigns/${campaign.id}`);
  };

  return (
    <>
      <PageContent>
        <CampaignForm
          onCancel={() => navigate(`/clients/${client.id}/campaigns`)}
          onSubmit={createCampaign}
          onSuccess={handleSuccess}
        />
      </PageContent>
    </>
  );
};

export default CampaignAddPage;
